import sty from '../../Settings/Settings.module.css';

const UpdateEmailSuccess = () => {
    return (
        <form className={sty['form']} data-testid="profile-form">
            <div className="inner-container">
                <div className={sty['update__mail']}>
                    <div className={sty['update__mail-tit']}>
                        <p className={sty['update__line-break']}>メールアドレスが変更されました</p>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default UpdateEmailSuccess;


